import React from 'react';
import { View, Text } from 'react-native';
import SchoolManagementScreenEnhanced from '@/screens/school/SchoolManagementScreenEnhanced';
import { useTabAccess } from '@/hooks/useTabAccess';
import { WebAppShell } from '@/design-system/components';

export const options = {
  headerShown: false,
};

export default function MoreSchoolManagementScreen() {
  const { user, showSchoolManagement } = useTabAccess();

  if (!showSchoolManagement) {
    return (
      <WebAppShell active="school-management" contentMaxWidth="100%" scroll={false}>
        <View style={{ flex: 1, alignItems: 'center', justifyContent: 'center', padding: 24 }}>
          <Text style={{ fontSize: 18, fontWeight: '600', color: '#1f2937', textAlign: 'center' }}>
            School management tools are limited to school administrators.
          </Text>
        </View>
      </WebAppShell>
    );
  }

  return (
    <WebAppShell active="school-management" contentMaxWidth="100%" scroll={false}>
      <SchoolManagementScreenEnhanced user={user ?? undefined} />
    </WebAppShell>
  );
}
